import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getStoreFilters } from './../../../apis/requests';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useLang from "../../../hooks/useLang";
import BrandsLoader from './BrandsLoader';
const ShopByBrands = () => {
    const { t } = useTranslation();
    const lang = useLang();
    const { data, isLoading } = useQuery({
        queryKey: ["getShopFilters"],
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
        queryFn: () => {
            return getStoreFilters();
        },
    });
    const filters = data?.data.filters || undefined;

    return (
        <div>
            <div className="p-6 lg:py-10 py-6 my-6">
                <div className="text-center">
                    <h1 className="text-4xl font-semibold text-[#004040]">Shop by Brands</h1>
                    <h2 className="text-xl font-medium py-2">Discover your perfect contact lenses from the world's leading optical brands.</h2>
                </div>
            </div>
            <div className="mx-4 mb-5">
                {
                    isLoading &&
                    <BrandsLoader />
                }
                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
                    {
                        !isLoading &&
                        filters.brands.map((brand) => {
                            return (
                                <div key={brand.id}>
                                    <Link
                                        to={"/shop/brand/" + brand.id + "/" + (lang === "en" ? brand.brand_name : brand.brand_name_ar)}
                                    >
                                        <img
                                            className="rounded-xl"
                                            loading="lazy"
                                            src={brand.brand_logo}
                                            alt={brand.brand_name}
                                        />
                                        <div className="flex items-center gap-2 my-2 text-[#004040]">
                                            <span className="font-semibold text-[#004040]">{lang === "en" ? brand.brand_name : brand.brand_name_ar}</span>
                                            <span className="material-symbols-outlined">
                                                {lang === "en" ? "arrow_right_alt" : "arrow_left_alt"}
                                            </span>
                                        </div>
                                    </Link>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default ShopByBrands;